import { Box, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import type { FC } from "react";
import { useEffect, useState } from "react";
import AsyncLoadingButton from "../../components/asyncLoadingButton/AsyncLoadingButton";
import CancelButton from "../../components/cancelButton/CancelButton";
import { Select } from "../../components/select/Select";
import type { ParticipantListStatus } from "./participantListStatus";
import { participantListStatusLabels } from "./participantListStatus";

const statusOptions = Object.entries(participantListStatusLabels).map(([value, label]) => ({
  value: value as ParticipantListStatus,
  label: label as string,
}));

interface Props {
  readonly open: boolean;
  readonly status: ParticipantListStatus;
  readonly onCancel: () => void;
  readonly onConfirm: (status: ParticipantListStatus) => Promise<void>;
}

const ParticipantListStatusDialog: FC<Props> = ({ open, status, onCancel, onConfirm }) => {
  const [selected, setSelected] = useState<ParticipantListStatus>(status);

  useEffect(() => {
    setSelected(status);
  }, [status, open]);

  return (
    <Dialog open={open} fullWidth maxWidth="xs">
      <DialogTitle>Zmień status listy uczestników</DialogTitle>
      <DialogContent>
        <Box
          sx={{
            marginTop: 1,
          }}
        >
          <Select label="Status" fullWidth value={selected} values={statusOptions} onSelect={setSelected} />
        </Box>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={onCancel} />
        <AsyncLoadingButton onClick={() => onConfirm(selected)}>Zmień</AsyncLoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default ParticipantListStatusDialog;
